module.exports = __webpack_public_path__ + "static/media/banner_mobile.e4e4e5b4.png";